import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSignOutAlt,
  faUsers,
  faTshirt,
  faInfo,
  faCalendarCheck,
  faCalendarAlt,
  faBullhorn,
  faCog
} from '@fortawesome/free-solid-svg-icons'

import * as Strings from './strings'
import * as Styles from './styles'

export const MainListItems = props => (
  <div>
    <ListItem button onClick={() => props.onUsersPressed()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faUsers} color={'#3B424D'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p>{Strings.default.USERS}</p>
      </ListItemText>
    </ListItem>
  </div>
)

export const LaundryListItems = props => (
  <div>
    <ListItem button onClick={() => props.onLaundryTimes()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faTshirt} color={'#3B424D'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p>{Strings.default.LAUNDRY_SETTINGS}</p>
      </ListItemText>
    </ListItem>
    <ListItem button onClick={() => props.onBooking()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faCalendarCheck} color={'#3B424D'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p>{Strings.default.LAUNDRY_BOOKINGS}</p>
      </ListItemText>
    </ListItem>
  </div>
)

export const BookableObjectListItems = props => (
  <div>
    <ListItem button onClick={() => props.onBookableObjects()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faCalendarAlt} color={'#3B424D'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p>{Strings.default.BOOKABLE_OBJECTS}</p>
      </ListItemText>
    </ListItem>
    <ListItem button onClick={() => props.onPastBookings()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faCalendarCheck} color={'#3B424D'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p>{Strings.default.BOOKING_SYSTEM_HISTORY}</p>
      </ListItemText>
    </ListItem>
  </div>
)

export const NewsFeedListItems = props => (
  <div>
    <ListItem button onClick={() => props.onNewsFeed()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faBullhorn} color={'#3B424D'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p>{Strings.default.NEWS}</p>
      </ListItemText>
    </ListItem>
  </div>
)

export const InfoListItems = props => (
  <div>
    <ListItem button onClick={() => props.onInfoSettings()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faInfo} color={'#3B424D'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p>{Strings.default.INFORMATION_SETTINGS}</p>
      </ListItemText>
    </ListItem>
  </div>
)

export const SecondaryListItems = props => (
  <div>
    <ListItem button onClick={() => props.onSignOut()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faSignOutAlt} color={'#e57373'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p style={{ color: '#e57373' }}>{Strings.default.SIGN_OUT}</p>
      </ListItemText>
    </ListItem>
  </div>
)

export const SettingsListItems = props => (
  <div>
    <ListItem button onClick={() => props.onSettings()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faCog} color={'#3B424D'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p>{Strings.default.SETTINGS}</p>
      </ListItemText>
    </ListItem>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/common/ListItems/index.js